import agreementIndex from '@/view/cancelAccount/index'
import cancelPage from '@/view/cancelAccount/cancelPage'
import userServiceAgreement from '@/view/cancelAccount/userServiceAgreement'

const CancelAccount = {
  path:'/cancelAccount',
  component: agreementIndex,
  children:[{
      path:'cancelPage',
      name: 'cancelPage',
      component: cancelPage,
      meta: {
        title: '用户注销',
        keepAlive: true,
      },
  },
    {
    path:'userServiceAgreement',
    name: 'userServiceAgreement',
    component: userServiceAgreement,
    meta: {
      title: '用户注销'
    }, 
  }]
}
export default CancelAccount
